import { erpToast } from 'design-system/components/erp-toast'

const showWarning = (message: string) => {
 erpToast.warning(message)
}

export default showWarning
